// extracted by mini-css-extract-plugin
export default {"termine":"WINcSfVVlcikHwM8siSt","bold":"j2JFuPatZ0Qbd9rqwvOf"};